import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

export const getSupplierListEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetSupplier`,
    method: 'get',
    params,
  });
};

export const getVisibilitySearchListEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetSearchResult`,
    method: 'post',
    data: params,
  });
};

export const getTrackingStatusDetailsEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetTrackingStatusDetails`,
    method: 'get',
    params,
  });
};

export const getProductInfoEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetProductInformation`,
    method: 'get',
    params,
  });
};

export const getShipmentNotesAndDetailsEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetShipmentNotesAndDetails`,
    method: 'GET',
    params,
  });
};

export const getShipperConsigneeDetailsEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetShipperConsignee`,
    method: 'GET',
    params,
  });
};

export const getTransportationProviderEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetTransportationProvider`,
    method: 'get',
    params,
  });
};

export const updateShipmentTrackingDetailsEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/UpdateShipmentTrackingDetails`,
    method: 'put',
    data: params,
  });
};

export const updateRefAndDockNoEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/UpdateReferenceAndDockNo`,
    method: 'put',
    data: params,
  });
};

export const getVisibilityExceptionEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetException`,
    method: 'post',
    data: params,
  });
};

export const getFooterContentEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetFooterContent`,
    method: 'post',
    data: params,
  });
};

export const sendEmailEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/SendEMail`,
    method: 'post',
    data: params,
  });
};

export const getVisibilityExportDetailsEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetShipmentPrintDetails`,
    method: 'get',
    params,
  });
};

export const getVisibilityExportExcelEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetVisibilityExportDetails`,
    method: 'post',
    data: params,
  });
};

let getShipperConsigneeSearchEffectsToken = () => {};
export const getShipperConsigneeSearchResult = (data) => {
  getShipperConsigneeSearchEffectsToken();
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetShipperConsigneeSearch`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' },
    cancelToken: new CancelToken(function executor(c) {
      getShipperConsigneeSearchEffectsToken = c;
    }),
  });
};

export const updateShipmentNoteEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/UpdateShipmentNote`,
    method: 'post',
    data: params,
  });
};

export const updateShipmentDetailsEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/UpdateShipmentDetails`,
    method: 'post',
    data: params,
  });
};

export const getVisibilityBranchsEffects = (params) => {
  return axiosInstance.request({
    url: `${API.VISIBILITY}/GetBranchs`,
    method: 'get',
    params,
  });
};
